import React from 'react';
import styled from '@emotion/styled';

import { BulletPoint } from '../../../types/types';
import { BenefitsTpPoints } from './BenefitsTpPoints';
import { BenefitsTpLaptop } from './BenefitsTpLaptop';
import { BenefitsTpHeader } from './BenefitsTpHeader';
import { BenefitsTpLogo } from './BenefitsTpLogo';
import { BenefitsTpLaptopContainer } from './BenefitsTpLaptopContainer';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

import { productComponentContainerPaddingStyle } from '../../shared/styles';

const BenefitsContentContainer = styled.div([
  productComponentContainerPaddingStyle,
  {
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto 0',

    [mqBreakpoints.desktop]: {
      alignItems: 'center',
      paddingTop: pxToRem(96),
    },
  },
]);

type Props = {
  title: string;
  points: BulletPoint[];
  description: string;
  image: string;
  logo: string;
  paletteBackgroundColor: string;
  paletteTextColor: string;
  index?: number;
};

export const BenefitsTp: React.FC<Props> = ({ index, title, points, description, image, logo, paletteBackgroundColor, paletteTextColor }) => {
  return (
    <BenefitsContentContainer id={`mp-product-benefits-${index}`} style={{ background: paletteBackgroundColor, color: paletteTextColor }} data-testid='mp-product-benefits--tp'>
      <BenefitsTpHeader title={title} strapline={description} />
      <BenefitsTpPoints points={points} />
      {(image || logo) && <BenefitsTpLaptopContainer>{image ? <BenefitsTpLaptop image={image} /> : <BenefitsTpLogo logo={logo} />}</BenefitsTpLaptopContainer>}
    </BenefitsContentContainer>
  );
};
